import { useEffect, useState } from "react";
import instance, { setAuthToken } from "../services/api";

export default function Profile() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    setAuthToken(localStorage.getItem("token"));
    instance
      .get("/profile/")
      .then((response) => {
        setProfile(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  return <h1>{profile?.email}</h1>;
}
